// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VzAWq","col":"styles_col__g4ULA"};